<script>
import { post } from '@/api'

export default {
  name: 'VcAside',

  data: () => ({
    isShowRuleMenu: localStorage.getItem('roleId'), // 1 系统管理员（可见规则菜单） 2 普通管理员
    activeIndex: sessionStorage.getItem('activeIndex') || '/home',
    menuList: localStorage.getItem('menuList'),
    isSuperAdmin: localStorage.getItem('roleId') === '1',
    isM: localStorage.getItem('roleId') === '1' || localStorage.getItem('roleId') === '2',
    isCustomer: localStorage.getItem('roleId') === '3',
    isManager: localStorage.getItem('roleId') === '5',
    isCM: localStorage.getItem('roleId') === '6', // 城市经理，暂按角色2权限处理
    zjhlList: [],
    zjhlDialog: false,
  }),
  watch: {
    activeIndex() {
      sessionStorage.setItem('activeIndex', this.activeIndex)
    },
    $route(newp, oldp) {
      if (newp.name === 'InsuranceDrivrLicenseImport' && oldp.name === 'InsuranceDrivrLicenseList') {
        this.activeIndex = '/insurance/driveLicense/infoimport'
      }
    },
  },
  methods: {
    handleNewQuotationClick() {
      // 设置标记，表示是从侧边栏菜单进入的新增车险报价
      sessionStorage.setItem('fromQuotationMenu', 'true')
    },
    async selectMenu(key) {
      this.activeIndex = key
      if (key === 'safe-learning') {
        const res = await post('/insurance/user/getTbatbToken')
        window.open(res.body.loginUrl)
      }
      if (key === 'zh-traffic') {
        const res = await post('/insurance/company/getCompanyList')
        const companyList = res.body.companyList
        if (companyList.length === 1) {
          window.open(companyList[0].loginUrl)
        }
        else {
          this.zjhlDialog = true
          this.zjhlList = companyList
        }
      }
    },
    jumploginUrl(loginUrl) {
      window.open(loginUrl)
      this.zjhlDialog = false
    },
    auth(name) {
      return this.isM || this.isCM || this.menuList.includes(name)
    },
  },
}
</script>

<template>
  <ElAside width="auto">
    <ElMenu :default-active="activeIndex" class="overflow-y-auto scrollbar" router @select="selectMenu">
      <ElMenuItem index="/home">
        <i class="el-icon-house" />
        <template #title>
          <span>系统首页</span>
        </template>
      </ElMenuItem>
      <ElSubmenu v-if="!isManager" index="/rate">
        <template #title>
          <i class="el-icon-position" />
          <span>货车评分</span>
        </template>
        <ElMenuItem index="/car-scoring/info">
          <template #title>
            <span>评分查询</span>
          </template>
        </ElMenuItem>
        <ElMenuItem index="/car-scoring/list">
          <template #title>
            <span>评分记录</span>
          </template>
        </ElMenuItem>
        <ElMenuItem index="/car-scoring/compare">
          <template #title>
            <span>对比提升</span>
          </template>
        </ElMenuItem>
        <ElMenuItem index="/car-scoring/guide">
          <template #title>
            <span>提升攻略</span>
          </template>
        </ElMenuItem>
      </ElSubmenu>
      <ElSubmenu index="/normal-quotation">
        <template #title>
          <i class="el-icon-position" />
          <span>车险报价</span>
        </template>
        <!-- 业务经理可发起报价，发起人显示"业务经理"；城市经理不可发起 -->
        <ElMenuItem v-if="!isCM" index="/normal-quotation/edit" @click="handleNewQuotationClick">
          <template #title>
            <span>新增车险报价</span>
          </template>
        </ElMenuItem>
        <ElMenuItem v-if="!isManager" index="/normal-quotation/list">
          <template #title>
            <span>普通报价记录</span>
          </template>
        </ElMenuItem>
        <ElMenuItem v-if="isManager" index="/normal-quotation/pending">
          <template #title>
            <span>待报价</span>
          </template>
        </ElMenuItem>
        <ElMenuItem v-if="isManager" index="/normal-quotation/quoted">
          <template #title>
            <span>报价列表</span>
          </template>
        </ElMenuItem>
        <ElMenuItem index="/normal-quotation/requote-records">
          <template #title>
            <span>确认提单价格</span>
          </template>
        </ElMenuItem>
        <ElMenuItem v-if="!isManager" index="/quotationRecord">
          <template #title>
            <span>快速报价记录</span>
          </template>
        </ElMenuItem>
        <ElMenuItem v-if="isM || isCM" index="/normal-quotation/bm-quotation">
          <template #title>
            <span>经理报价记录</span>
          </template>
        </ElMenuItem>
      </ElSubmenu>
      <ElSubmenu index="/quotation-comparison">
        <template #title>
          <i class="el-icon-position" />
          <span v-if="isM || isCM">净费比较</span>
          <span v-else>净费计算</span>
        </template>
        <ElMenuItem index="/quotation-comparison/edit">
          <template #title>
            <span v-if="isManager">新增净费</span>
            <span v-else>新增车险净费</span>
          </template>
        </ElMenuItem>
        <ElMenuItem index="/quotation-comparison/list">
          <template #title>
            <span v-if="isManager">净费记录</span>
            <span v-else>车险净费记录</span>
          </template>
        </ElMenuItem>
        <ElMenuItem v-if="!isManager" index="/netFeeRecord/netfee">
          <template #title>
            <span>车险快速净费</span>
          </template>
        </ElMenuItem>
        <ElMenuItem v-if="isM || isCM" index="/quotation-comparison/edit-ratio">
          <template #title>
            <span>修改比例</span>
          </template>
        </ElMenuItem>
      </ElSubmenu>
      <ElSubmenu v-if="!isManager" index="/non-vehicle-insurance">
        <template #title>
          <i class="el-icon-position" />
          <span>非车报价</span>
        </template>
        <ElMenuItem index="/non-vehicle-insurance/quotation">
          <template #title>
            <span>快速报价</span>
          </template>
        </ElMenuItem>
        <ElMenuItem v-if="isM || isCM" index="/non-vehicle-insurance/config">
          <template #title>
            <span>规则配置</span>
          </template>
        </ElMenuItem>
        <!-- <ElMenuItem v-if="$store.getters.isManager" index="/non-vehicle-insurance/index">
          <template #title>
            <span>规则配置</span>
          </template>
        </ElMenuItem>
        <ElMenuItem v-if="$store.getters.isManager" index="/non-vehicle-insurance/create-quotation-record">
          <template #title>
            <span>新增报价</span>
          </template>
        </ElMenuItem>
        <ElMenuItem v-if="$store.getters.isManager" index="/non-vehicle-insurance/quotation-record">
          <template #title>
            <span>非车报价</span>
          </template>
        </ElMenuItem> -->
      </ElSubmenu>
      <ElSubmenu v-if="!isCustomer" index="/messageSettings">
        <template #title>
          <i class="el-icon-setting" />
          <span>信息设置</span>
        </template>
        <ElMenuItem v-if="isM || isCM || isManager" index="/messageSettings">
          规则设置
        </ElMenuItem>
        <ElMenuItem v-if="isM || isCM" index="/scoring-legend">
          政策指引
        </ElMenuItem>
        <ElMenuItem v-if="isSuperAdmin" index="/messages">
          系统消息
        </ElMenuItem>
        <ElMenuItem v-if="isSuperAdmin" index="/poster-upload">
          海报上传
        </ElMenuItem>
      </ElSubmenu>
      <ElSubmenu index="/user-manage">
        <template #title>
          <i class="el-icon-setting" />
          <span>用户管理</span>
        </template>
        <ElMenuItem v-if="auth() || isManager" index="/user-manage/list">
          <i class="el-icon-user" />
          <template #title>
            <span>用户列表</span>
          </template>
        </ElMenuItem>
        <ElMenuItem v-if="auth() || isManager" index="/company/list">
          <i class="el-icon-house" />
          <template #title>
            <span>公司列表</span>
          </template>
        </ElMenuItem>
        <ElMenuItem v-if="isSuperAdmin || isCustomer" index="/register-user/list">
          <i class="el-icon-user" />
          <template #title>
            <span>注册司机</span>
          </template>
        </ElMenuItem>
        <ElMenuItem v-if="isM || isCustomer || isCM" index="/business-manager/list">
          <i class="el-icon-user-solid" />
          <template #title>
            <span>业务经理</span>
          </template>
        </ElMenuItem>
        <ElMenuItem v-if="isM" index="/city-manager/list">
          <i class="el-icon-user-solid" />
          <template #title>
            <span>城市经理</span>
          </template>
        </ElMenuItem>
      </ElSubmenu>
      <ElSubmenu v-if="auth('保单管理') || isManager" index="/insurance">
        <template #title>
          <i class="el-icon-s-management" />
          <span>保单管理</span>
        </template>
        <ElSubmenu index="/insurance/vehicle">
          <template #title>
            <i class="el-icon-edit" />
            <span>车险保单</span>
          </template>
          <ElMenuItem index="/insurance/vehicle/infoimport">
            保单导入
          </ElMenuItem>
          <ElMenuItem index="/insurance/vehicle/list">
            保单查询
          </ElMenuItem>
        </ElSubmenu>
        <ElSubmenu index="/insurance/NonAutoPolicy">
          <template #title>
            <i class="el-icon-edit" />
            <span>非车险保单</span>
          </template>
          <ElMenuItem index="/insurance/NonAutoPolicy/infoimport">
            保单导入
          </ElMenuItem>
          <ElMenuItem index="/insurance/NonAutoPolicy/list">
            保单查询
          </ElMenuItem>
        </ElSubmenu>
      </ElSubmenu>
      <ElSubmenu v-if="auth('车辆管理')" index="/insurance/driveLicens">
        <template #title>
          <i class="el-icon-truck" />
          <span>车辆管理</span>
        </template>
        <ElMenuItem index="/insurance/driveLicense/infoimport">
          车辆信息及档案导入
        </ElMenuItem>
        <ElMenuItem index="/insurance/driveLicense/list">
          年审信息及档案查询
        </ElMenuItem>
      </ElSubmenu>
      <ElSubmenu v-if="!isManager && !isCM" index="/inventory">
        <template #title>
          <i class="el-icon-truck" />
          <span>清单报表</span>
        </template>
        <ElMenuItem index="/inventory/insurance">
          车辆保险清单
        </ElMenuItem>
        <ElMenuItem index="/inventory/parking">
          车辆报停清单
        </ElMenuItem>
        <ElMenuItem index="/inventory/cases">
          车辆报案清单
        </ElMenuItem>
        <ElMenuItem index="/inventory/tracking">
          发票跟踪清单
        </ElMenuItem>
      </ElSubmenu>
      <ElMenuItem v-if="!isManager && !isCM" index="safe-learning">
        <template #title>
          <i class="el-icon-notebook-2" />
          <span>安全学习</span>
        </template>
      </ElMenuItem>
      <ElMenuItem v-if="!isManager && !isCM" index="zh-traffic">
        <template #title>
          <i class="el-icon-notebook-2" />
          <span>北斗设备</span>
        </template>
      </ElMenuItem>
      <ElSubmenu v-if="isSuperAdmin" index="/statistics">
        <template #title>
          <i class="el-icon-data-analysis" />
          <span>统计看板</span>
        </template>
        <ElMenuItem index="/statistics/analysis">
          <template #title>
            <span>统计分析</span>
          </template>
        </ElMenuItem>
        <ElMenuItem index="/statistics/customer-analysis">
          <template #title>
            <span>客户分析</span>
          </template>
        </ElMenuItem>
      </ElSubmenu>
      <ElSubmenu v-if="!isCM" index="/my">
        <template #title>
          <i class="el-icon-user" />
          <span>我的</span>
        </template>
        <ElMenuItem index="/my/points">
          <template #title>
            <span>积分明细</span>
          </template>
        </ElMenuItem>
        <ElMenuItem v-if="!isManager" index="/my/payment-history/list">
          <template #title>
            <span>支付记录</span>
          </template>
        </ElMenuItem>
      </ElSubmenu>
    </ElMenu>
    <ElDialog :visible="zjhlDialog" @close="zjhlDialog = false">
      <p>请选择要登录的中交慧连账号</p>
      <!-- table 表格 -->
      <div class="zjhl">
        <span v-for="(item, index) in zjhlList" :key="index" class="zjhl-item" @click="jumploginUrl(item.loginUrl)">{{
          item.name }}</span>
      </div>
    </ElDialog>
  </ElAside>
</template>

<style lang="scss" scoped>
.el-aside {
  position: relative;
}

.el-menu {
  height: 100%;
  background: #dddddd;

  &:not(.el-menu--collapse) {
    min-width: 180px;
  }
}

.zjhl {
  .zjhl-item {
    display: inline-block;
    width: calc(33.33% - 10px);
    height: 50px;
    line-height: 50px;
    text-align: center;
    background: #fff;
    margin: 5px;
    border-radius: 5px;
    border: 1px solid #888;
  }
}
</style>
